import { render } from "./add-agents.vue?vue&type=template&id=1ce9fd3c&scoped=true"
import script from "./add-agents.vue?vue&type=script&lang=js"
export * from "./add-agents.vue?vue&type=script&lang=js"

import "./add-agents.vue?vue&type=style&index=0&id=1ce9fd3c&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce9fd3c"]])

export default __exports__